import { Modal, useHooks } from '@everlywell/leaves';
import React, { useContext, useEffect, useRef } from 'react';
import { MEMBERSHIP_CARD } from 'utils/constants/dataTest';
import { logError } from 'utils/helpers';
import { UserSettingsContext } from 'utils/hooks/useAccountSettings/context';

import { CreditRedemptionModalContext } from 'utils/hooks/useCreditRedemptionModal/context';
import ShippingSettings from '../ShippingSettings';
import CONTENT from './content';
import * as S from './styles';

const CreditRedemptionModal = () => {
  const buttonRef = useRef<HTMLInputElement>(null);
  const { shippingAddress, savedShippingInfo, resetState } =
    useContext(UserSettingsContext);

  const {
    _openCreditRedemptionModal,
    closeCreditRedemptionModal,
    processCreditRedemptionModalOrder,
  } = useContext(CreditRedemptionModalContext);

  const disableSubmitButton = (disabled: boolean) =>
    buttonRef &&
    buttonRef.current &&
    buttonRef.current.setAttribute('disabled', `${disabled}`);

  const onSubmit = async () => {
    try {
      disableSubmitButton(true);
      await processCreditRedemptionModalOrder();
    } catch (err) {
      logError('Error submitting credit redemption modal', {
        component: 'CreditRedemptionModal',
        method: 'onSubmit',
        err,
      });
      disableSubmitButton(false);
    }
  };

  useHooks.useDisableScroll(_openCreditRedemptionModal);

  useEffect(() => {
    if (!_openCreditRedemptionModal) resetState && resetState();
  }, [_openCreditRedemptionModal]);

  return (
    <Modal
      open={_openCreditRedemptionModal}
      openHandler={() => closeCreditRedemptionModal()}
      persist
    >
      <S.Title>{CONTENT.modal.title}</S.Title>
      <S.Description>{CONTENT.modal.message}</S.Description>

      <S.Address>
        <ShippingSettings smallSave>
          {(editing: boolean) => (
            <>
              <div>
                {savedShippingInfo && (
                  <S.SavedBlurb>
                    <S.InfoIcon>
                      <S.Icon />
                    </S.InfoIcon>
                    <S.Content>{CONTENT.blurb}</S.Content>
                  </S.SavedBlurb>
                )}
              </div>
              <S.Button
                ref={buttonRef}
                appearance="primary"
                onClick={onSubmit}
                data-testid={MEMBERSHIP_CARD.ORDER_TEST_MODAL}
                isDisabled={!shippingAddress?.address1 || editing}
              >
                Order
              </S.Button>
            </>
          )}
        </ShippingSettings>
      </S.Address>
    </Modal>
  );
};

export default CreditRedemptionModal;
